import React from 'react';
import { Button } from 'antd';

/**
 * What a list says when nothing matches the person's search or filters: one
 * line that names the search, and the way back (KPR-740, docs/platform-standards.md
 * section 5, Empty states). It is never the empty-collection state - that is
 * `NoItemsEmptyState`, and it only ever speaks for a list nothing narrows.
 *
 *   term='camry', otherFilters   ->  No items match “camry”   [Clear search] [Clear filters]
 *   term='camry'                 ->  No items match “camry”   [Clear search]
 *   no term                      ->  No items match           [Clear filters]
 *
 * `onClearSearch` takes only the term off; `onClearFilters` is the list's
 * own way back from its other filters (and, on the collection list, takes the
 * term with it). `children` are further buttons the list owns.
 */
export default function NoItemsMatch({
	term = '',
	otherFilters = false,
	onClearSearch,
	onClearFilters,
	clearFiltersLabel = 'Clear filters',
	className = 'items-page__empty',
	children = null,
}) {
	const searched = Boolean(term);
	return (
		<div className={`${className} no-items-match`} data-testid='no-items-match'>
			<span className='no-items-match__text'>
				{searched ? `No items match “${term}”` : 'No items match'}
			</span>
			<span className='no-items-match__actions'>
				{searched ? <Button onClick={onClearSearch}>Clear search</Button> : null}
				{(otherFilters || !searched) && onClearFilters ? (
					<Button onClick={onClearFilters}>{clearFiltersLabel}</Button>
				) : null}
				{children}
			</span>
		</div>
	);
}
